import { createContext, FC, useContext, useMemo } from 'react';

import { AppConfig, useGetAppConfigQuery } from '../../graphql/generated';

export type AppConfigContextValue = Omit<AppConfig, '__typename' | 'version'>;

const AppConfigContext = createContext<AppConfigContextValue>({
  canDownloadPiiReport: false,
  canManageUsers: false,
  canViewProblemFiles: false,
});

export const AppConfigProvider: FC<{ value?: AppConfigContextValue }> = (
  props
) => {
  const { data } = useGetAppConfigQuery();

  const contextValue = useMemo(() => {
    if (!data?.appConfig) return {
      canDownloadPiiReport: false,
      canManageUsers: false,
      canViewProblemFiles: false,
    };
    
    return {
      canDownloadPiiReport: data.appConfig.canDownloadPiiReport,
      canManageUsers: data.appConfig.canManageUsers,
      canViewProblemFiles: data.appConfig.canViewProblemFiles,
    };
  }, [data?.appConfig]);

  if (!data?.appConfig) return null;

  return <AppConfigContext.Provider value={contextValue} {...props} />;
};

export const useAppConfig = (): AppConfigContextValue => {
  return useContext(AppConfigContext);
};
